import { render, staticRenderFns } from "./header.component.vue?vue&type=template&id=96894cb8&scoped=true&"
import script from "./header.component.ts?vue&type=script&lang=ts&"
export * from "./header.component.ts?vue&type=script&lang=ts&"
import style0 from "./header.component.scss?vue&type=style&index=0&id=96894cb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96894cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
